import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {
  public message: string = this.route.snapshot.paramMap.get('message');

  constructor(protected route: ActivatedRoute) {}

  ngOnInit(): void {}
}
